export const stringToCard = (string) => {
  return string?.match(/.{1,4}/g)?.join(' ');
};
